import { ONE_SECOND_MS } from '@shared/utils'

// The registry issues the title deed ~30 s after an order clears, so a fresh
// order's documents list starts empty. Poll it every 10 s for a minute.
export const TITLE_DEED_POLL_INTERVAL_MS = 10 * ONE_SECOND_MS
export const TITLE_DEED_POLL_WINDOW_MS = 60 * ONE_SECOND_MS

export const ORDER_DOCUMENT_LABEL = {
  receipt: 'Order Receipt',
  titleDeed: 'Title Deed Certificate',
} as const

export type OrderDocumentKind = keyof typeof ORDER_DOCUMENT_LABEL

export const ORDER_DOCUMENT_TOAST = {
  receipt: 'Receipt downloaded successfully!',
  titleDeed: 'Title Deed Certificate downloaded successfully!',
  failed: 'Download failed. Please try again.',
} as const
